import 'alpinejs'

window.$ = window.jQuery = require('jquery');
window.Swal = require('sweetalert2');

// CoreUI
require('@coreui/coreui');
// Boilerplate
require('../bootstrap');
require('../plugins');
require('../utils/select2');
require('../utils/masks');
require('../utils/datepicker');
require('../utils/qrcode');

// require('./calendar');

const Highcharts = require('highcharts');
require('highcharts/modules/exporting')(Highcharts);
window.Highcharts = require('highcharts/modules/exporting')(Highcharts);

const { getCurrentSignature } = require('./signature');


//////////////////////////////////////


require('./tickets');


function onSubmitSignature(idNameForm){
    const form = document.getElementById(idNameForm);
    console.log(form)
    if(form) {
        form.onsubmit = function (e) {
            e.preventDefault();
            const inptSig = document.querySelector('input#signature');
            
            if(inptSig){
                const signature = getCurrentSignature();
                console.log(signature);
            
                inptSig.value = signature;

            } 

            // else {
            //     Swal.fire({
            //         icon: 'error',
            //         title: 'Oops...',
            //         text: 'Erro ao processar a assinatura!',
            //     });
            // }


            form.submit();
        }
    }
}

onSubmitSignature('confirm-census');
onSubmitSignature('create-parcel');
onSubmitSignature('set-parcel-deliver');



async function setResidentByLot({dwellerInputName, dwellerIdAttributeName, userIdAttributeName, userTextInputName} = {}, ) {
    const lotId = $('select[name="lot_id"]');
    const bootstrapInput = async (option) => {
        if (option) {   
            const dwellerInputSelect = $(`select[name="${dwellerInputName}"]`);
            if (dwellerInputSelect) {
                const userIdAttribute = option.getAttribute(userIdAttributeName);
                const receivedUserText = $(`input[name="${userTextInputName}"]`);

                receivedUserText.val('');

                dwellerInputSelect.find('option').not(':first').remove().trigger("change");

                if (userIdAttribute) {
                    axios.get(`/admin/auth/user/${userIdAttribute}/get-name`, {
                    }).then(({data: name}) => {
                       
                        if (receivedUserText) {
                            receivedUserText.val(name);
                        }
    
                    });
    
                    const {data: options} = await axios.post('/admin/resident/dweller/get-by-user', {
                        user_id: userIdAttribute
                    });

                    const residentDwellerId = dwellerInputSelect.data(dwellerIdAttributeName);
                    

                    for await (const opt of options) {
                        const newOption = new Option(opt.name, opt.id, residentDwellerId == opt.id, residentDwellerId == opt.id);
                        dwellerInputSelect.append(newOption);
                    }
                    

                    if (!residentDwellerId) {
                        dwellerInputSelect.val(0).trigger('change');
                    }

                    dwellerInputSelect.trigger('change'); 
                }    
            }
        }
    }

    if (lotId) {
        const element = lotId.get(0);
        if (element) {
            const option = element.options[element.selectedIndex];
        
            await bootstrapInput(option);

            lotId.on("select2:select", async (evt) => {
                const element = evt.target;
                const option = element.options[element.selectedIndex];
                await bootstrapInput(option);
            });

            lotId.on("select2:clear", async (evt) => {
                const element = evt.target;
                const option = element.options[element.selectedIndex];
                await bootstrapInput(option);
            })
        }
    }
}


$(window).on('load', function() {
    // Parcel
    setResidentByLot({dwellerInputName: 'received_dweller_id', dwellerIdAttributeName: 'received-dweller-id', userIdAttributeName: 'data-resident-id', userTextInputName: 'received_user_id'});
    // Booking
    setResidentByLot({dwellerInputName: 'dweller_id', dwellerIdAttributeName: '', userIdAttributeName: 'data-user-id', userTextInputName: 'user_id'});
});